import React from 'react';
import { Box, Button, TextField, SxProps, Theme, CssBaseline, InputLabel } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { error } from 'console';

interface TextAreaWithButtonProps {
  errorMessage?: string;
  label: string;
  inputValue: string;
  onChange: (value: string) => void;
  onClick: () => void;
  buttonText: string;
  ariaLabel: string;
  disabled: boolean;
  type?: string;
  buttonColor?: 'primary' | 'success';
  prefilled?: boolean;
  verified?: boolean;
  helperText?:string;
  timer?: number;
}

function TextAreaWithButton(props: TextAreaWithButtonProps): JSX.Element {
  const {
    errorMessage,
    label,
    inputValue,
    onChange,
    onClick,
    buttonText,
    ariaLabel,
    disabled,
    type,
    prefilled,
    verified,
    timer,
    helperText
  } = props;

  const textFieldSx: SxProps<Theme> = { 
    ariaLabel: ariaLabel, 
    paddingBottom: "56px"
  };

  const buttonSx: SxProps<Theme> = { 
    padding: '4px 8px',
    fontSize: "0.75rem"    
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevents page refresh
  };

  console.log(errorMessage);
  return (
    <Box 
    component="form"
    onSubmit={handleSubmit}
    sx={{ 
      width: '100%',
      marginBottom: "0.5rem",
    }}
    >
    <CssBaseline enableColorScheme/>
    <InputLabel shrink htmlFor="text-field"
      sx={{ fontSize: '1.80rem' }}
    >
         <b> {label} </b>
        </InputLabel>
      <TextField

        id='text-field'
        error={!!errorMessage}
        label=""
        value={inputValue} 
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        autoFocus
        fullWidth
        variant="outlined"
        // sx={textFieldSx}
        type={type}
        disabled={!!(prefilled || verified || (timer ?? 0 >0))}
        sx={{
          ...textFieldSx,
          'label + &': {
            marginTop: "0px",
          },
          '& .MuiOutlinedInput-root.Mui-disabled': {
            backgroundColor: verified ? '#e8f5e9' : '#f0f0f0', // Green for verified, light grey for default disabled
            color: verified ? '#2e7d32' : '#000000', // Text color for verified
          }
        }}
        // type={type}
        // disabled={prefilled}
        color={verified ? "success" : "secondary"}
      />
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          marginTop: '-100px',
          marginRight: '8px',
          
        }}
      >
        {!verified ? (
          <Button
            size="small"
            variant="contained"
            color="primary"
            sx={buttonSx}
            onClick={onClick}
            disabled={disabled}
          >
            {buttonText}
          </Button>
        ) : (
          // Placeholder Box to maintain layout consistency
          <Box sx={{ ...buttonSx, visibility: 'hidden' }}>
            {/* Empty space with same size as the button */}
            {buttonText}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default TextAreaWithButton;